module.exports = __webpack_public_path__ + "resources/img/img_coolfilter6_m.e91be196a6d7e993b161572a408d7f2b.png";